<template>
  <div class="hero section-quote" id="section-quote">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column box section is-5 has-text-centered section-quote-box" style="">
            <p style="padding:30px;">{{ quoteContent }}<br />
              <a @click="refreshQuote()" title="Refresh quote" style="margin-right:10px;"><i class="fa fa-refresh" style="vertical-align:middle;"></i></a>
              <a :href="quoteContentUrl" target="_blank" title="Tweet this quote!"><i class="fa fa-twitter" style="vertical-align:middle;"></i></a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'section-quote',
    components: {
    },
    data () {
      return {
        quoteContent: ''
      }
    },
    computed: {
      quoteContentUrl: function () {
        return 'https://twitter.com/intent/tweet?text=' + encodeURI(this.quoteContent)
      }
    },
    created () {
    },
    mounted () {
      this.refreshQuote()
    },
    methods: {
      refreshQuote: function () {
        var quotes = ['Don\'t complain about the snow on your neighbour\'s roof when your own doorstep is unclean. — Confucious',
          'A great man shows his greatness by the way he treats little men. ― Thomas Carlyle',
          'I can\'t imagine a man really enjoying a book and reading it only once. ― C.S. Lewis',
          'If I find in myself a desire which no experience in this world can satisfy, the most probable explanation is that I was made for another world. ― C.S. Lewis',
          'They that be whole need not a physician, but they that are sick.',
          'Every kingdom divided against itself is brought to desolation, and every city or house divided against itself shall not stand.',
          'He is no fool who gives what he cannot keep to gain that which he cannot lose. ― Jim Elliot',
          'The journey of a thousand miles begins with a single step. ― Laozi',
          'Give a man a fish and you feed him for a day. Teach him how to fish and you feed him for a lifetime.',
          'No! Try not. Do... or do not. There is no try. ― Yoda',
          'A neutron walks into a bar and asks how much for a drink. The barman replies for you no charge. ― Sheldon Cooper',
          'Sheldon: \'Well, this is confusing for me. But I don\'t want to stand in the way of your happiness. So, I will condemn you internally while maintaining an outward appearance of acceptance.\'',
          'My fists are not up here because I am milking a giant invisible cow. ― Sheldon Cooper',
          'Almost every successful person begins with two beliefs...the future can be better than the present, and I have the power to make it so. ― Zig Ziglar',
          'Remember that failure is an event, not a person. ― Zig Ziglar',
          'The more you complain about your problems, the more problems you will have to complain about. ― Zig Ziglar',
          'Far too many people have no idea what they can do because all they\'ve been told is what they can\'t do. ― Zig Ziglar',
          'The master has failed more times than the beginner has even tried. ― Zig Ziglar',
          'Your character should always be stronger than your circumstances. ― Zig Ziglar',
          'All our dreams can come true if we have the courage to pursue them. ― Walt Disney',
          'Done is better than perfect. - Anonymous'
        ]
        var randomNumber = Math.floor(Math.random() * quotes.length)
        this.quoteContent = quotes[randomNumber]
        console.log(this.quoteContent)
      }
    }
  }
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.section-quote {
  transition: visibility 0s linear 0s,opacity .4s 0s;
  background-color: $color-blue;

  .hero-body {
    padding-top: 0;
  }

  &-box {
    font-size: 0.9em;
    color: $color-white;
    background-color: transparent;
    margin-top: 80px;
    box-shadow: 0 0 0, 0 0 0 0;

    @media screen and (max-width: $mobile) {
      margin-top: 0px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// ContentQuoteSection.vue?44de7982